import React, { useEffect } from "react";
import { getCart } from "../pages/cart/CartMangement";
import cart from "../assets/icons/cart.svg";

interface CustomCartIconProps {
  itemCount: number;
  setItemCount: React.Dispatch<React.SetStateAction<number>>;
  onClick?: () => void;
  cartRef?: any;
}

const CustomCartIcon: React.FC<CustomCartIconProps> = ({ itemCount, setItemCount, onClick, cartRef }) => {
  const updateItemCount = () => {
    const cart = getCart()
    const totalItems = Array.isArray(cart.items) ? cart.items.length : 0;
    setItemCount(totalItems);
  };

  useEffect(() => {
    updateItemCount();
    window.addEventListener("storage", updateItemCount);
    return () => {
      window.removeEventListener("storage", updateItemCount);
    };
  }, []);

  (window as any).updateCartCount = updateItemCount;

  return (
    <div onClick={onClick}
      style={{
        position: "relative",
        cursor: "pointer"
      }}
      {...(cartRef ? { ref: cartRef } : {})}
    >
      <img src={cart} alt="Cart" className="icon" />
      {itemCount > 0 && (
        <span
          style={{
            position: "absolute",
            top: "10%",
            left: "90%",
            transform: "translate(-50%, -50%)",
            width: '22px',
            height: '22px',
            lineHeight: '20px',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '12px',
            color: 'var(--white-color)',
            backgroundColor: 'var(--primary-color)',
          }}
        >
          {itemCount}
        </span>
      )}
    </div>
  );
};

export default CustomCartIcon;
